import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tx-section-search-fields',
  templateUrl: './section-search-fields.component.html',
  styleUrls: ['./section-search-fields.component.scss'],
})
export class SectionSearchFieldsComponent {
  @Input() disabled: boolean = false;
  public searchTerm: string = '';
  @Output() searchClicked: EventEmitter<string> = new EventEmitter<string>();

  onClearClicked() {
    this.searchTerm = '';
    this.onFindClicked();
  }

  onFindClicked() {
    this.searchClicked.emit(this.searchTerm);
  }
}
